export default __webpack_public_path__ + "static/how-it-works-d9b0f2435cf9955085af25945bbbdcf2.mp4";